/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionP2P } from './TransactionP2P';
import {
    TransactionP2PFromJSON,
    TransactionP2PFromJSONTyped,
    TransactionP2PToJSON,
} from './TransactionP2P';

/**
 * 
 * @export
 * @interface SendPaymentOutput
 */
export interface SendPaymentOutput {
    /**
     * 
     * @type {TransactionP2P}
     * @memberof SendPaymentOutput
     */
    transaction?: TransactionP2P;
    /**
     * 
     * @type {Error}
     * @memberof SendPaymentOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the SendPaymentOutput interface.
 */
export function instanceOfSendPaymentOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SendPaymentOutputFromJSON(json: any): SendPaymentOutput {
    return SendPaymentOutputFromJSONTyped(json, false);
}

export function SendPaymentOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendPaymentOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction': !exists(json, 'transaction') ? undefined : TransactionP2PFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function SendPaymentOutputToJSON(value?: SendPaymentOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction': TransactionP2PToJSON(value.transaction),
        'error': value.error,
    };
}

